import { getNbDecimal, roundDecimal } from "components/helper/numberHelper";

interface WeightedAnswer {
    weight: number;
}

// Votes the voter has not distributed yet among the options.
export function getRemainingWeight(
    voterWeight: number,
    answers: Array<WeightedAnswer>,
): number {
    return answers.reduce(
        (remaining, answer) =>
            roundDecimal(remaining - answer.weight, getNbDecimal(voterWeight)),
        voterWeight,
    );
}
